import {Aboutus} from './aboutus'
import {Persons} from './persons'
import {AboutFeature} from './aboutFeature'
import {ShowCaseHorizontal} from './showcaseHorizontal'
import {Feature} from './feature'
import {FeatureEdit} from './featureEdit'
import {Projects} from './projects'
import {Friendship} from './friendship'
import {Profiles} from './profiles'
import {Fields} from './fields'

export const Center = () => { 
  return (
    <div>
      <Aboutus />
      <div className='mt-3 mb-3'>
        <Persons />
      </div>   
      <Fields /> 
      <AboutFeature   />
      <ShowCaseHorizontal />
      <Feature />
      <FeatureEdit />
      <Projects />
      <Friendship />
      <Profiles />
    </div>
  )
}
  